import { SvgIconComponent } from '@mui/icons-material'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined'
import AreaChartOutlinedIcon from '@mui/icons-material/AreaChartOutlined'
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import LandscapeOutlinedIcon from '@mui/icons-material/LandscapeOutlined'
import ListOutlinedIcon from '@mui/icons-material/ListOutlined'
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined'
import LocalPoliceOutlinedIcon from '@mui/icons-material/LocalPoliceOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined'
import MapOutlinedIcon from '@mui/icons-material/MapOutlined'
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined'
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined'
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined'
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined'
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined'
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined'

export const ICON_MAP: Record<string, SvgIconComponent> = {
  add: AddOutlinedIcon,
  apps: AppsOutlinedIcon,
  archive: ArchiveOutlinedIcon,
  autoAwesome: AutoAwesomeOutlinedIcon,
  chart: AreaChartOutlinedIcon,
  chevronRight: ChevronRightOutlinedIcon,
  create: CreateOutlinedIcon,
  dashboard: DashboardOutlinedIcon,
  dateRange: DateRangeOutlinedIcon,
  delete: DeleteOutlinedIcon,
  download: DownloadOutlinedIcon,
  duplicate: ContentCopyOutlinedIcon,
  filter: FilterAltOutlinedIcon,
  info: InfoOutlinedIcon,
  landscape: LandscapeOutlinedIcon,
  localPolice: LocalPoliceOutlinedIcon,
  list: ListOutlinedIcon,
  location: LocationOnOutlinedIcon,
  logout: LogoutOutlinedIcon,
  manageAccount: ManageAccountsOutlinedIcon,
  map: MapOutlinedIcon,
  menu: MenuOutlinedIcon,
  money: AttachMoneyOutlinedIcon,
  more: MoreVertOutlinedIcon,
  phone: LocalPhoneOutlinedIcon,
  policy: PolicyOutlinedIcon,
  public: PublicOutlinedIcon,
  publish: PublishOutlinedIcon,
  pin: PinDropOutlinedIcon,
  receipt: ReceiptOutlinedIcon,
  settings: SettingsOutlinedIcon,
  shipping: LocalShippingOutlinedIcon,
  sync: SyncAltOutlinedIcon,
  undo: UndoOutlinedIcon,
}
